import useElapsedTime from '../ClockCounter/useElapsedTime';

type Props = {
  startAt: string;
};

function TripTimerCaption({ startAt }: Props): JSX.Element {
  const elapsed = useElapsedTime(startAt);

  return <span>{`Trip duration: ${elapsed}`}</span>;
}

export default TripTimerCaption;
